import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CalendarItemService, CalendarItem } from '../../services/calendar-item.service';
import { EditEntityBaseClass } from '../EditEntityBaseClass';
import { ReligionBranchSummary, ReligionBranchServiceService } from '../../services/religion-branch.service';
import { ServiceSummary, ServiceService } from '../../services/service.service';
import { SeasonService } from '../../services/season.service';
import { Season } from '../../../../objects';
import { ServiceBuilder } from 'selenium-webdriver/edge';

@Component({
  selector: 'app-calendar-item-edit',
  templateUrl: './calendar-item-edit.component.html',
  styleUrls: ['./calendar-item-edit.component.css']
})
export class CalendarItemEditComponent extends EditEntityBaseClass implements OnInit {

  public item: CalendarItem;
  public title: string;
  public listsLoaded: boolean;
  public recurringServiceName: string;

  public religionBranches: ReligionBranchSummary[];
  public seasons: Season[];

  public assignedServices: string[];
  public excludedServices: string[];

  constructor(
    private dialog: MatDialogRef<CalendarItemEditComponent>,
    private calendarItemSvc: CalendarItemService, 
    private religionBranchSvc: ReligionBranchServiceService,
    private seasonSvc: SeasonService,
    private serviceSvc: ServiceService
  ) { 
    super();
  }

  ngOnInit() {
  
    this.recurringServiceName = "";
    this.currentLocalizedData = null;

    if (this.item != null && this.item.Localized != null) {
      this.currentLocalizedData = this.item.Localized[0];
    }

    var religionBranchPromise = this.religionBranchSvc.loadEntities().then(
      (data) => {
        this.religionBranches = data;
      }
    );

    var seasonPromise = this.seasonSvc.loadEntites().then(
      (data) => {
        this.seasons = data;
      }
    );

    Promise.all([
      religionBranchPromise,
      seasonPromise
    ]).then(
    (data) => {
      console.log("All promises are completed");
      this.listsLoaded = true;
    }
  )

  }

  public LoadItem(itemId: string) {

    this.listsLoaded = false;

    this.assignedServices = [];
    this.excludedServices = [];

    if (itemId == null) {
      this.title = "Add New Calendar Item";
      this.item = new CalendarItem(); 
      this.item.RecurrenceType = 0;

      this.listsLoaded = true;
      
    } else {
      this.title = "Edit Calendar Item";
  
      console.log("Loading Existing Item", itemId);

      var x = this.calendarItemSvc.getItem(itemId).then(
        (data: CalendarItem) => {
          this.item = data;
 

          this.assignedServices = this.GetArrayFromString(this.item.RecurrentAssignedServicesIdString);
          this.excludedServices = this.GetArrayFromString(this.item.RecurrentExcludedServicesIdString);
    
          console.log("calendarItem loaded", data); 
          this.currentLocalizedData = this.item.Localized[0];
 
        }
      );

 
    }
 
    console.log("LoadItem", itemId ,this.listsLoaded);
     
  } 

  private GetArrayFromString(strValue: string) : string[] { 
    if (strValue != null && strValue != "") {
      var str = strValue.split("|");
      return str;
    }
    return [];
  }

  private GetStringFromArray(arr: string[]) : string { 
    if (arr != null) {
      var str = arr.join("|");
      return str;
    }
    return "";
  }


  public compareSeason(obj1: Season, obj2: Season) { 
      //console.log("Comparing", obj1, obj2);
      if (obj1 == undefined) {return false;}
     if (obj1.Id === obj2.Id) { return true };
     return false;
   }

  public cancel() {
    this.dialog.close();
  }

  public save() {

    console.clear();
 
    this.item.RecurrentAssignedServicesIdString = this.GetStringFromArray(this.assignedServices);
    this.item.RecurrentExcludedServicesIdString = this.GetStringFromArray(this.excludedServices);

    console.log("SAVE", this.item);
    this.calendarItemSvc.save(this.item).then(
      (data) => {
        console.log("item saved", data);
        this.dialog.close(data);
      })
      .catch( 
        (err)=> {
            alert("Error: " + err);
        }
      );
  }
 
  // public serviceSuggestSelected(service: ServiceSummary) {
  //   console.log("serviceSuggestSelected", service); 
  //   //this.item.RecurrenceServiceId = service.Id;
  // }

  public reloadItem() {
    this.LoadItem(this.item.Id);
  }

  public detectAssignedServiceChanges(services: string[]) {
    this.assignedServices = services;
    console.log("detectAssignedServiceChanges", services);
  }

  public detectExcludedServiceChanges(services: string[]) {
    this.excludedServices = services;
    console.log("detectExcludedServiceChanges", services);
  }

}
